import { SnackbarProvider as LibSnackbarProvider } from 'notistack';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    pointerEvents: 'auto',
  },
  '@global': {
    '.SnackbarContainer-root': {
      gap: theme.spacing(),
    },
  },
}));

export default function SnackbarProvider({ children }) {
  const classes = useStyles();
  return (
    <LibSnackbarProvider maxSnack={3} classes={{ root: classes.root }}>
      {children}
    </LibSnackbarProvider>
  );
}
